import React from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useGoogleSSO } from './hooks/useGoogleSSO';
import { useSelector } from 'react-redux';
import { UserData } from './model/User';
import { AxiosResponse } from 'axios';
import { ApplicationState } from 'store/store';
import { Throbber } from 'lib/Throbber';

interface GoogleSSOProps {
    onSignInSuccess: (data: UserData) => void;
    onSignInError: (error: AxiosResponse<{ message: string; code: string }>) => void;
    onStart?: () => void;
    /** Width within the parent Grid container — defaults to 12 (full row). Pass 6 to sit
     *  alongside another half-width SSO button. */
    size?: number;
    /** Horizontal alignment of the SSO button within its Grid column. Defaults to center.
     *  Pass `flex-end` when sitting beside an Apple button to push them together. */
    justify?: 'flex-start' | 'center' | 'flex-end';
}

export const GoogleSSO: React.FC<React.PropsWithChildren<GoogleSSOProps>> = ({
    onSignInSuccess,
    onSignInError,
    onStart,
    size = 12,
    justify = 'center'
}) => {
    const { settings } = useSelector((state: ApplicationState) => state.settings);

    const { googleSSOId, container, loading } = useGoogleSSO(onSignInSuccess, onSignInError, onStart);
    if (!settings?.googleSSOEnabled) {
        return null;
    }
    return (
        <Grid ref={container} size={size}>
            <Box display="flex" justifyContent={justify}>
                <div id={googleSSOId} />
            </Box>
            {loading && <Throbber isFullScreen text="" />}
        </Grid>
    );
};
